module.exports = __webpack_public_path__ + "static/thumb-outdoor-api-7c1552a956153c92a59db6c15b3cfd36.png";